import { ItemStatus } from '@/constants/item'
import { AlertTriangle, CheckCircle2, Clock, PackageCheck, Send, Sparkles, Wrench } from 'lucide-react'

export function ItemStatusIcon({ status }: { status: ItemStatus }) {
  switch (status) {
    case 'Available':
      return <CheckCircle2 className="size-3 text-success" />
    case 'InUse':
      return <Clock className="size-3 text-info" />
    case 'Maintenance':
      return <Wrench className="size-3 text-warning" />
    case 'Missing':
      return <AlertTriangle className="size-3 text-destructive" />
    case 'Retired':
      return <PackageCheck className="size-3 text-slate-500" />
    case 'PendingTransfer':
      return <Send className="size-3 text-primary" />
    case 'Cleaning':
      return <Sparkles className="size-3 text-cyan-500" />
    default:
      return null
  }
}
